import { Copy01Icon, Tick01Icon } from "@hugeicons/core-free-icons"
import { type ComponentProps, useState } from "react"
import IconButton from "./IconButton"

type Props = Omit<ComponentProps<typeof IconButton>, "icon" | "onClick"> & {
  text: string
}

export default function CopyButton({ text, ...rest }: Props) {
  const [copied, setCopied] = useState(false)

  const handleClick = async () => {
    await navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, Math.E * 250)
  }

  return (
    <IconButton
      icon={copied ? Tick01Icon : Copy01Icon}
      onClick={handleClick}
      {...rest}
    />
  )
}
